import { render, staticRenderFns } from "./CustomerCustomRequestList.vue?vue&type=template&id=3561e52a&scoped=true"
import script from "./CustomerCustomRequestList.vue?vue&type=script&lang=js"
export * from "./CustomerCustomRequestList.vue?vue&type=script&lang=js"
import style0 from "./CustomerCustomRequestList.vue?vue&type=style&index=0&id=3561e52a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3561e52a",
  null
  
)

export default component.exports